import { IPB } from 'Components/publisher/publisher'
import fetch from 'lib/decorated-fetch'
export const mockNewCard = async (props: IPB) => {
  const {
    imgs,
    video,
    community,
    topic,
    time,
    async_to_toutiao,
    type,
    content,
    gid,
    user_id,
  } = props

  let type_str
  switch (type) {
  case 'picture':
    type_str = 2300
    break
  case 'video':
    type_str = 2303
    break
  case 'qa':
    type_str = 2318
    break
  default:
    type_str = 'ugc_article'
    break
  }
  const { video_id, videoInfo } = video || {}
  const { thumb_uri } = videoInfo || {}
  const { motor_id, series_id, communityName } = community
  try {
    const json = await fetch(
      `/motor/profile/m/get_profile_head?the_user_id=${user_id}&version_code=617&user_id=${user_id}`
    )
    const behot_time = new Date().getTime() / 1000
    const newData = {
      info: {
        behot_time,
        image_list: imgs?.map(e => ({ uri: e.uri })) || [],
        digg_count: 0,
        comment_count: 0,
        user_info: {
          ...(json.data?.info || {}),
          name: json.data?.info?.nick_name,
        },
        user_digg: false,
        title: content,
        video_id,
        video_thumb_url: [{ uri: thumb_uri }],
        label_tag_list: [
          {
            name: communityName,
            image: {
              url:
                'https://sf3-ttcdn-tos.pstatp.com/obj/motor-img/58f5ceb88bdf405d2b57637db1e2bebf',
            },
            concern_id: series_id,
          },
        ],
        comment_list: [],
      },
      type: type_str,
      unique_id_str: gid,
      disabled: true,
    }
    return newData
  } catch (error) {
    console.error(error)
    return null
  }
}
